import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { TRANSACTIONS_PATH } from "utils/constants/paths";

const Transactions = Loadable(React.lazy(() => import("./View")));

export const TransactionsRoute: IRouteItem = {
  path: TRANSACTIONS_PATH,
  iconName: "MoneyRecive",
  element: React.createElement(Transactions),
  name: "Transactions",
  accessKeys: ["Analyst"],
};
